import { render, staticRenderFns } from "./V-botton.vue?vue&type=template&id=5948ac98&scoped=true&"
import script from "./V-botton.vue?vue&type=script&lang=js&"
export * from "./V-botton.vue?vue&type=script&lang=js&"
import style0 from "./V-botton.vue?vue&type=style&index=0&id=5948ac98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5948ac98",
  null
  
)

export default component.exports